import React, { useEffect, useState } from 'react';
import styles from './GeoRedirectModal.module.scss';

const GeoRedirectModal = () => {
  const [show, setShow] = useState(false);

  /* 1.  No hagas petición si el usuario ya lo rechazó */
  useEffect(() => {
    if (localStorage.getItem('peRedirectDismissed') === 'true') return;

    /* 2. Consulta al backend PHP */
    fetch('/country.php')
      .then(r => (r.ok ? r.json() : Promise.reject()))
      .then(({ country }) => {
        if (country === 'PE') setShow(true);
      })
      .catch(() => {
        /* Falla silenciosamente: no bloquea la app */
      });
  }, []);

  /* 3. Acciones del modal */
  const goToPe = () => {
    window.location.href = 'https://www.zoomlion.com.pe';
  };

  const dismiss = () => {
    localStorage.setItem('peRedirectDismissed', 'true');
    setShow(false);
  };

  /* 4. Render (nulo si no corresponde mostrar) */
  if (!show) return null;

  return (
    <div className={styles.backdrop}>
      <div className={styles.modal} role="dialog" aria-modal="true">
        <button
          className={styles.closeBtn}
          onClick={dismiss}
          aria-label="Cerrar"
        >
          ×
        </button>

        <p className={styles.text}>Parece que estás visitándonos desde Perú.</p>
        <p className={styles.text}>¿Quieres ir al sitio oficial de Zoomlion Perú?</p>

        <button className={styles.goBtn} onClick={goToPe}>
          Ir a sitio Perú
        </button>
      </div>
    </div>
  );
};

export default GeoRedirectModal;
